



































































import { Component, Mixins, Ref } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";
import AxiosMixin from "@/mixins/axiosMixin";
import EditMixin from "@/mixins/editMixin";
import MasmenMixin from "@/mixins/masmenMixin";
import OfficeSelect from "@/components/common_ibow/OfficeSelect.vue";
import { OfficeUserSetting } from "#/model/agreement/officeUserSetting";
import RulesMixin from "#/mixins/rulesMixin";
import { VForm } from "@/types";

@Component({ components: { OfficeSelect } })
export default class extends Mixins(
  UtilMixin,
  EditMixin,
  AxiosMixin,
  MasmenMixin,
  RulesMixin
) {
  @Ref("agreement-dialog") private readonly agreementForm!: VForm;
  @Ref("office-dialog") private readonly officeForm!: VForm;

  /** 選択事業所ID */
  private officeId = 0;

  /** 事業所メールアドレス */
  private officeUserSetting: OfficeUserSetting = {
    id: 0,
    office_id: 0,
    agreement_id: 0,
    csv_mail_address: "",
    created_at: "",
    updated_at: "",
    deleted_at: ""
  };

  /** 出力可能年月 */
  private files: { yearmonth: number; yearmonth_str: string }[] = [];

  private created() {
    if (this.loginUser.parent_office_id > 0) {
      // 主たる事業所のみ表示するので初期値は主たる事業所にする
      this.officeId = this.loginUser.parent_office_id;
      this.fetch();
    }
  }

  /** 法人・事業所設定情報取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/master/csv-setting/get",
      {
        office_id: this.officeId
      },
      res => {
        this.files = res.data.office_csv_files;
        this.officeUserSetting = res.data.office_user_setting;
        this.setLoaded();
      }
    );
  }

  /** 法人メールアドレス保存 */
  private saveAgreementMailAdress() {
    if (!this.agreementForm.validate()) {
      return;
    }

    if (!this.agreementUserSetting.csv_mail_address) {
      this.$openAlert("②全事業所 通知先メールアドレス を入力してください");
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/master/group/covid19setting/save",
      { agreement_user_setting: this.agreementUserSetting },
      () => {
        //
      }
    );
  }

  /** 事業所メールアドレス保存 */
  private saveOfficeMailAdress() {
    if (!this.officeForm.validate()) {
      return;
    }

    if (!this.officeUserSetting.csv_mail_address) {
      this.$openAlert("①事業所別 通知先メールアドレス を入力してください");
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/master/csv-setting/save",
      { office_user_setting: this.officeUserSetting },
      () => {
        //
      }
    );
  }

  /** Zipダウンロード */
  private async output(yearmonth: number): Promise<void> {
    this.postJsonBlobResCheck(
      window.base_heavy_url + "/api/master/csv-setting/output",
      { office_id: this.officeId, yearmonth: yearmonth },
      res => {
        this.downloadFile(res.data, "csv.zip");
      }
    );
  }

  /** ファイルのダウンロード */
  private downloadFile(blobable: Blob, fileName: string): void {
    if (!blobable.size) return;
    const blob = new Blob([blobable]);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.click();
  }

  // メアドの形式チェック
  private checkMail(mailaddress: string) {
    if (!mailaddress) {
      return "必須です。";
    }
    return this.emailFormat(
      mailaddress,
      "メールアドレスの形式が正しくありません。"
    );
  }
}
